export default "__VITE_ASSET__CCxI_SbW__"